import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { SanitizeHTMLString } from "@circle-react-uikit/SanitizeContent";
import { Typography } from "@circle-react-uikit/Typography";

const localeNamespace = "settings.emails.templates";

export function DeleteConfirmationModal({
  templateName,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: {
  templateName: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={t([localeNamespace, "delete_template"])}
      onConfirm={onConfirm}
      confirmVariant="danger"
      confirmText={isLoading ? t("deleting") : t("delete")}
      cancelText={t("cancel")}
      disabled={isLoading}
    >
      <Typography.LabelMd>
        <SanitizeHTMLString
          content={t([localeNamespace, "delete_template_description"], {
            name: templateName,
          })}
        />
      </Typography.LabelMd>
    </ConfirmationModal>
  );
}
